import React from 'react'

import { type RestoringParams } from './types'
import { useCreateRestoringParams } from './useCreateRestoringParams'

export const useRestoringParams = (hash: RestoringParams['hash']) => {
  const createRestoringParams = useCreateRestoringParams()

  return React.useMemo(
    () => createRestoringParams(hash),
    [createRestoringParams, hash],
  )
}
